import { useMemo } from 'react';
import { useQuery, UseQueryResult } from 'react-query';
import { useSelector } from 'react-redux';

import { PublicApplicationAPI } from '@lib/api/endpoints/Applications';
import { RootState } from '@lib/redux.lib/store';

export const useGetJobsBoardPost = (
  applicationUuid: string
): UseQueryResult<JobsBoardApplication, Error> => {
  const loggedInUserId = useSelector(
    (state: RootState) => state.app?.user?.profile?.id
  );
  const queryKey = useMemo(() => {
    if (loggedInUserId) {
      return ['jobsBoardPostPrivate', applicationUuid, loggedInUserId];
    }

    return ['jobsBoardPostPublic', applicationUuid];
  }, [loggedInUserId, applicationUuid]);

  const queryOptions = useMemo(
    () => ({
      queryKey,
      queryFn: () => {
        if (loggedInUserId) {
          return PublicApplicationAPI.getJobsBoardPost(
            applicationUuid,
            loggedInUserId
          );
        }

        return PublicApplicationAPI.getJobsBoardPostPublic(applicationUuid);
      },
      enabled: !!applicationUuid,
    }),
    [queryKey, loggedInUserId, applicationUuid]
  );

  return useQuery<JobsBoardApplication, Error>(queryOptions);
};
